<template>
    <div class="checkboxFieldContainer">
        <input type="checkbox"
               :id="id"
               :checked="checked"
               @input="event => $emit('update:checked', event.target.checked)"
               :required="required"/>
        <label :for=label>{{ label }} <a :href="termsAndConditionsUrl" target="_blank">{{ termsAndConditions }}</a> & <a :href="privacyUrl" target="_blank">{{ privacyText }}</a><!--*--></label>
    </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
    name: 'checkboxField',
    emits: ['update:checked'],
    props: {
        label: {
            type: String,
            required: false,
            default: ""
        },
        id: {
            type: String,
            required: true,
            default: ""
        },
        checked: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        termsAndConditionsUrl: {
            type: String,
            required: false,
            default: ''
        },
        privacyText: {
            type: String,
            required: false,
            default: 'privacyverklaring'
        },
        privacyUrl: {
            type: String,
            required: false,
            default: ''
        },
        termsAndConditions: {
            type: String,
            required: false,
            default: 'algemene voorwaarden'
        }
    },
    setup() {
        return {}
    }
})
</script>

<style scoped lang="scss">
div.checkboxFieldContainer {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

div.checkboxFieldContainer > label {
  margin: 0 0 0 5px !important;
}
</style>